<template>
  <div class="monitor-list">
    <div class="btn" style="margin-left: 5px" @click="scrollLeft">
      <i class="el-icon el-icon-arrow-left" />
    </div>
    <div id="sensor-list-box" class="sensor-list-box">
      <div id="sensor-list" class="sensor-list">
        <div
          v-for="(item, index) in monitorList"
          :key="index"
          class="sensor-list-item"
          :class="'sensor-list-item' + index"
          @click="showChartViewHandler(item, index)"
        >
          <div class="sensor-list-item-name">
            <span>{{ item.showName || item.name }}</span>
            <i
              class="el-icon-message-solid"
              style="color: #ff3c3b; margin-left: 5px"
              v-if="item.alarmState && item.alarmState !== 0"
            ></i>
          </div>
          <div
            class="sensor-list-item-value"
            v-if="item.name == 'pm1' || item.name == 'pm25'"
            :style="{
              color: item.color
            }"
          >
            {{ item.value }}
          </div>
          <div class="sensor-list-item-value" v-else :class="'value' + item.alarmState">
            {{ item.showValue || item.value }}
          </div>
          <div class="sensor-list-item-unit">{{ item.unitName }}</div>
        </div>
      </div>
    </div>
    <div class="btn" style="margin-right: 5px" @click="scrollRight">
      <i class="el-icon-arrow-right" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    monitorList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    // 左滑动逻辑
    scrollLeft() {
      this.$emit('coloseChartView');
      const allLength = this.monitorList.length * 120;
      const boxLength = document.getElementById('sensor-list-box').clientWidth;
      if (allLength < boxLength) return;
      const listEl = document.getElementById('sensor-list');
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));
      if (leftMove + boxLength - 360 < boxLength) {
        listEl.style.left = '0px';
      } else {
        listEl.style.left = '-' + (leftMove - 360) + 'px';
      }
    },
    // 右滑动逻辑
    scrollRight() {
      this.$emit('coloseChartView');
      const allLength = this.monitorList.length * 200;
      const boxLength = document.getElementById('sensor-list-box').clientWidth;
      if (allLength < boxLength) return;
      const listEl = document.getElementById('sensor-list');
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));
      if (leftMove + boxLength + 360 > allLength) {
        listEl.style.left = '-' + (allLength - boxLength) + 'px';
      } else {
        listEl.style.left = '-' + (leftMove + 360) + 'px';
      }
    },
    showChartViewHandler(item, index) {
      this.$emit('showChart', item, index);
    }
  }
};
</script>

<style scoped lang="scss">
.monitor-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  pointer-events: none;

  .btn {
    pointer-events: all;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background-color: rgba(27, 171, 253, 0.5);
    color: var(--drone-list-arrow-font-color);
    font-size: 12px;
  }
  .sensor-list-box {
    width: calc(100% - 120px);
    overflow: hidden;

    .sensor-list {
      width: 100%;
      display: flex;
      transform: all 2s;
      .sensor-list-item {
        pointer-events: all;
        cursor: pointer;
        height: 100px;
        width: 160px;
        min-width: 160px;
        padding: 10px;
        box-sizing: border-box;
        text-align: center;
        color: var(--drone-list-base-font-color);
        background: var(--drone-sensor-bg-color);
        border-right: 1px solid #abe0ff;
        &-name,
        &-unit {
          font-size: 18px;
        }
        &-value {
          font-size: 22px;
          font-weight: bold;
        }
        .value0 {
          color: #00e401;
        }
        .value1 {
          color: #f8d51f;
        }
        .value2 {
          color: #ff3c3b;
        }
        .value3 {
          color: #ff7e01;
        }
        &:hover {
          background-color: var(--drone-sensor-bg-hover-color);
        }
      }
      position: relative;
      left: 0;
      transition: left 1s;
    }
  }
}
</style>
